import React from "react"
import { FormGroup, Label, FormFeedback } from "reactstrap"

const RadioInput = ({
    label,
    name,
    validation,
    options = [], // Array of { value, label, icon }
    helperText,
    readOnly = false,
    required = false,
    className = "",
    emptyText, // Custom empty text for readonly mode
    showIcons = false, // Whether to show icons with options
    inline = false, // Whether to display radio buttons inline
    ...rest
}) => {
    const showHelperText = !readOnly && helperText
    const hasError = validation.touched[name] && validation.errors[name]
    const selectedValue = validation.values[name]
    const isRequired = required && !readOnly

    // Get display value for readonly mode
    const getDisplayValue = () => {
        if (readOnly && !selectedValue) {
            const fieldName = label ? label.replace("*", "").trim() : name
            return emptyText || `${fieldName} not selected`
        }
        if (readOnly && selectedValue) {
            const selectedOption = options.find(opt => opt.value === selectedValue)
            return selectedOption ? selectedOption.label : selectedValue
        }
        return ""
    }

    // Get display icon for readonly mode
    const getDisplayIcon = () => {
        if (readOnly && selectedValue && showIcons) {
            const selectedOption = options.find(opt => opt.value === selectedValue)
            return selectedOption ? selectedOption.icon : null
        }
        return null
    }

    // Handle radio change
    const handleChange = (e) => {
        validation.setFieldValue(name, e.target.value)
    }

    return (
        <FormGroup className={`mb-3 ${className}`}>
            {label && (
                <Label className="form-label">
                    {label}
                    {isRequired ? "*" : ""}
                </Label>
            )}

            {!readOnly ? (
                <div className={`${inline ? 'd-flex gap-3' : ''}`}>
                    {options.map((option, index) => (
                        <div key={option.value} className={`form-check ${inline ? '' : 'mb-2'}`}>
                            <input
                                type="radio"
                                className="form-check-input"
                                id={`${name}_${index}`}
                                name={name}
                                value={option.value}
                                checked={selectedValue === option.value}
                                onClick={handleChange}
                                onBlur={validation.handleBlur}
                                {...rest}
                            />
                            <label
                                className="form-check-label d-flex align-items-center"
                                htmlFor={`${name}_${index}`}
                            >
                                {showIcons && option.icon && (
                                    <i className={`${option.icon} me-2`} style={{ width: '16px', textAlign: 'center' }}></i>
                                )}
                                <span>{option.label}</span>
                            </label>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="form-control input-as-text d-flex align-items-center">
                    {getDisplayIcon() && (
                        <i className={`${getDisplayIcon()} me-2`} style={{ width: '16px', textAlign: 'center' }}></i>
                    )}
                    <span className={!selectedValue ? "text-danger" : ""}>
                        {getDisplayValue()}
                    </span>
                </div>
            )}

            {hasError ? (
                <FormFeedback type="invalid" className="d-block">
                    {validation.errors[name]}
                </FormFeedback>
            ) : null}

            {showHelperText && (
                <span className="text-muted text-end d-inline-block w-100">
                    {helperText}
                </span>
            )}
        </FormGroup>
    )
}

export default RadioInput